// Après connexion, revenir à la page demandée au lieu de l'accueil, pour les pages où l'on arrive de l'extérieur :
// la page de consentement d'un connecteur MCP (OAuth, sinon la demande de claude.ai serait perdue) et les liens du
// PLM imprimés en QR code sur une pièce, une carte ou une étiquette (/plm/<pièce>/<version>, /inventory?stock=…),
// scannés depuis un téléphone pas encore connecté. Le reste de l'application garde son comportement.
const KEY = 'deepflow.apres_connexion';
const ALLOWED = ['/agent-access/connecteur', '/plm/', '/inventory'];

const allowed = (path) => ALLOWED.some((prefix) => path.startsWith(prefix));

export const rememberReturnPath = (location = window.location) => {
  const path = location?.pathname || '';
  if (!allowed(path)) return;
  try {
    sessionStorage.setItem(KEY, path + (location.search || ''));
  } catch (error) {
    // Stockage indisponible (navigation privée) : retour à l'accueil.
  }
};

export const takeReturnPath = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && allowed(path) ? path : null;
  } catch (error) {
    return null;
  }
};
